export default "__VITE_ASSET__YX4$N_e4__"